export default "__VITE_ASSET__vrx_FaIq__";